import { create } from "zustand";
import { persist } from "zustand/middleware";
import i18n from "@/i18n";

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      setAuth: (token, user) => set({ token, user }),
      setUser: (user) => set({ user }),
      logout: () => set({ token: null, user: null }),
    }),
    { name: "chittrack:auth" }
  )
);

export const useLangStore = create(
  persist(
    (set) => ({
      lang: typeof window !== "undefined" ? localStorage.getItem("chittrack:lang") || "en" : "en",
      setLang: (lang) => {
        localStorage.setItem("chittrack:lang", lang);
        i18n.changeLanguage(lang);
        set({ lang });
      },
    }),
    { name: "chittrack:lang-store" }
  )
);
